import { render, staticRenderFns } from "./SearchSugguestListBody.vue?vue&type=template&id=90fee9f4&scoped=true&"
import script from "./SearchSugguestListBody.vue?vue&type=script&lang=js&"
export * from "./SearchSugguestListBody.vue?vue&type=script&lang=js&"
import style0 from "./SearchSugguestListBody.vue?vue&type=style&index=0&id=90fee9f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fee9f4",
  null
  
)

export default component.exports